module.exports = __webpack_public_path__ + "img/strength-speed.704c599a.png";